function updateObject(newObj, obj) {
  Object.keys(newObj).forEach(function (key) {
    obj[key] = newObj[key]
  })
}

export default updateObject
